import {NgModule} from '@angular/core';
import {StatusSelectComponent} from './status-select.component';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {CommonModule} from '@angular/common';
import {StatusChangeFormComponent} from './status-change-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {LayoutModule} from '../../layout-components/layout.module';
import {IconsModule} from '@lab365/icons';

/**
 * Абстрактный модуль изменения статусов сущностей.
 * Перед использованием в те компоненты, в которых используется, добавить
 *
 * {provide: 'StatusChangeService', useClass: StatusChangeService},
 * {provide: 'StatusProvider', useClass: StatusesProvider},
 *
 *
 * По хорошему стоило использовать какой-нибудь static forChild метод, в который передавать провайдеры,
 * чтобы модуль сам потом их использовал,
 * но в этом случае последнее использование статичного метода переопределяет провайдеры первых вызовов.
 * Другими словами, когда я вызываю StatusChangeFormModule.forChild(providerA, providerB) в оборудовании и потом то же самое
 * в специалистах, но со своими провайдерами, то все равно в оборудовании используется провайдеры специалистов, так как они переопределили
 * значения оборудования. Пока не хвататет смекалки, как бы передать нужные провайдеры для выполнения, кроме как
 * указывать их локально ручками в каждом месте, где нужно, а не на модуль в целом.
 */

@NgModule({
    imports: [
        FormFieldModule,
        CommonModule,
        ReactiveFormsModule,
        LayoutModule,
        IconsModule,
    ],
    exports: [
        StatusChangeFormComponent,
        StatusSelectComponent,
    ],
    declarations: [
        StatusSelectComponent,
        StatusChangeFormComponent,
    ],
    providers: [],
})
export class StatusChangeFormModule {

}
